/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedFrequentlyAskedQuestions_buyPage$ref = any;
export type BuySharedFrequentlyAskedQuestions_buyPage = {
    readonly frequentlyAskedQuestions: ReadonlyArray<{
        readonly question: string | null;
        readonly answer: string | null;
    } | null> | null;
    readonly " $refType": BuySharedFrequentlyAskedQuestions_buyPage$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedFrequentlyAskedQuestions_buyPage",
  "type": "BuyPageConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "frequentlyAskedQuestions",
      "storageKey": null,
      "args": null,
      "concreteType": "BuyPageFrequentlyAskedQuestionType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "question",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "answer",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '9e7ea30cf06a1b467c7400c60105d059';
export default node;
